import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil, tap } from 'rxjs/operators';
import * as _ from 'lodash';
import { AssetService } from '@app/core/services/asset.service';
import { AssetSearchCriteriaModel } from '@app/core/models/assets/asset-search-criteria.model';
import { AssetTypeModel } from '@app/core/models/assets/asset-type.model';
import { ReferentialItem } from '@app/core/models/shared/referential-item.model';
import { RecipientEntitiesService } from '@app/core/services/recipient-entities.service';
import { RecipientEntitySearchCriteriaModel } from '@app/core/models/recipient-entity/recipient-entity-search-criteria.model';
import { EventEmitter } from '@angular/core';

export abstract class CommonService {

    unsubscribe$: Subject<boolean> = new Subject<boolean>();

    assetSearchEvent$: Subject<[string, AssetTypeModel]> = new Subject<[string, AssetTypeModel]>();
    recipientEntitySearchEvent$: Subject<string> = new Subject<string>();
    onAssetDataAvailable: EventEmitter<any> = new EventEmitter<any>();

    public assetSearchedName: string;
    public recipientEntitySearchedName: string;

    constructor(
        protected assetService: AssetService,
        protected recipientEntityService: RecipientEntitiesService) {

        this.assetSearchEvent$
            .pipe(
                debounceTime(250),
                distinctUntilChanged(),
                tap(filterData => {
                    if (!_.isNil(filterData)) {
                        this.assetSearchedName = filterData[0];
                        this.assetService.getPagedAssetsByType({
                            Reference: this.assetSearchedName,
                            AssetTypes: !_.isNil(filterData[1]) ? [filterData[1]] : undefined
                        } as AssetSearchCriteriaModel, 'Label', 'asc', 0, 30)
                            .subscribe(data => {
                                this.onAssetFetched(data.Items);
                                this.onAssetDataAvailable.emit();
                            });
                    }
                })).pipe(takeUntil(this.unsubscribe$)).subscribe();



        this.recipientEntitySearchEvent$
            .pipe(
                debounceTime(250),
                distinctUntilChanged(),
                tap(filterData => {
                    if (!_.isNil(filterData)) {
                        this.assetSearchedName = filterData;
                        this.recipientEntityService.getPagedRecipientEntityReferential({
                            Name: this.assetSearchedName
                        } as RecipientEntitySearchCriteriaModel, 'Label', 'asc', 0, 30)
                            .subscribe(data => {
                                this.onRecipientEntitiesFetched(data.Items);
                            });
                    }
                })).pipe(takeUntil(this.unsubscribe$)).subscribe();


        this.assetSearchEvent$.next([null, null]);
        this.recipientEntitySearchEvent$.next('');
    }

    public onAssetFilterChange(data: string, assetTypes?: AssetTypeModel) {
        this.assetSearchEvent$.next([data, assetTypes]);
    }

    public onRecipientEntityFilterChange(data: string) {
        this.recipientEntitySearchEvent$.next(data);
    }

    protected abstract onAssetFetched(assets: ReferentialItem[]);

    protected abstract onRecipientEntitiesFetched(recipientEntities: ReferentialItem[]);
}
